import { IEnvironmentConfig } from '@/types/environment';

/**
 * Production Environment Configuration
 */
export const environment: IEnvironmentConfig = {
  production: true,

  debug: {
    console: false,
  },

  analytics: {
    googleId: 'G-CR720QD9X7', // Replace with your production GA ID
    clarityId: 'tfhigis153', // Production Clarity project
    metaPixelId: '1429474625230810', // Production Meta Pixel ID
    enabled: true,
  },

  api: {
    phpApiUrl: 'https://api.omceanbooking.com',
    agentApiUrl: 'https://api.omceanbooking.com',
    demoAppUrl: 'https://app.omceanbooking.com/demoapt/home',
  },

  sentry: {
    dsn: 'https://948ebc974a85d65427701194a9a2ffd9@o1255800.ingest.us.sentry.io/4509818599243776',
    environment: 'production',
    release: 'omceanbooking-1793776771',
    enabled: true,
    tracesSampleRate: 0.1,
  },

  site: {
    url: 'https://www.omceanbooking.com',
    googleSiteVerification: 'Vr8XeWk-luKbz8kS8BmE1zjR4NuzbrkoNThAA_NHgfk',
    facebookDomainVerification: 'zbvulgi8fo3w39nsw25784vithwii1',
  },
};
